import { render, staticRenderFns } from "./PostPin.vue?vue&type=template&id=f70ce82e&scoped=true"
import script from "./PostPin.vue?vue&type=script&lang=js"
export * from "./PostPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70ce82e",
  null
  
)

export default component.exports